import React from 'react';
import Pane from "./Pane";
import ProgressBar from "./ProgressBar";
import PrimaryTitle from "./PrimaryTitle";
import Loader from "./Loader";

const PageLoadingPanel = (props) => {
    const {
        pageTitle           = '',
        currentStepNumber   = 1,
        totalStepNumber     = 1,
        upperTextComponent  = null
    } = props;

    return (
        <React.Fragment>
            {!!upperTextComponent && upperTextComponent}
            <Pane>
                <ProgressBar
                    title={pageTitle}
                    currentStepNumber={currentStepNumber}
                    totalStepNumber={totalStepNumber}
                />
                <PrimaryTitle>{pageTitle}</PrimaryTitle>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Loader />
                </div>
            </Pane>
        </React.Fragment>
    );
}

export default PageLoadingPanel;
